import React from "react";
import PropTypes from "prop-types";
import DigitalChannelDesktop from "./DigitalChannesDesktop";

function PositivacaoCategory({ app, config }) {
  return <DigitalChannelDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
